export default __webpack_public_path__ + "static/media/spacetime.49e03e4e.gif";